import { render, staticRenderFns } from "./assessStatistics.vue?vue&type=template&id=2864e25c&scoped=true&"
import script from "./assessStatistics.vue?vue&type=script&lang=js&"
export * from "./assessStatistics.vue?vue&type=script&lang=js&"
import style0 from "./assessStatistics.vue?vue&type=style&index=0&id=2864e25c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2864e25c",
  null
  
)

export default component.exports